export default __webpack_public_path__ + "static/media/Monitoramento (Real Size).a59fa605.svg";